export enum COUNTRY{
  KR='KR',
  CN='CN',
  JP='JP'
}

declare global {
  interface Window {
    ECHAT: {
      customMiniChat: (a:Record<string, any>) => void;
      closeMiniChat:(obj:Record<string, any>)=>void;
    };
    _echat:(name:string, obj:Record<string, any>)=>void;
    WECHAT:{
      wxEncrypt:(value:string, key:string, appid:string)=>string;
    }
  }
}

export {}
